<template>
	<div class="block">
		<div class="card">
			<div class="card-header solo">
				<h3>
					<a :href="ctx + '/serviceencontact.html#scrollToMessages'">Mijn berichten 
						<span class="newmessages" v-if="unread.ongelezen > 0">{{ unread.ongelezen }}</span>						
						<span class="newmessages loader" v-if="!pageDataLoaded">
							<div class="loaderframe">
								<div class="preloader loading">
									<span class="slice"></span>
									<span class="slice"></span>
									<span class="slice"></span>
									<span class="slice"></span>
									<span class="slice"></span>
									<span class="slice"></span>
								</div>
							</div>
						</span>
					</a>
				</h3>
			</div>
		</div>
	</div>
</template>

<script> 

export default {
	name: 'berichtongelezenknop-component',
	props: {
		ctx: String
		},
	data: function () {
		return {
			unread: "",
            pageDataLoaded: false
		}
	},
  	mounted: function () {		 
		var self = this;

		$.ajax({
			url: this.ctx + "/services/berichten/getongelezen",
			type: 'GET',
			success: function(data) {
				self.unread = data;
				self.pageDataLoaded = true
			}		
		});
	}
}

</script>




// WEBPACK FOOTER //
// bericht-ongelezenknop.vue?5be72228